import { faShareAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import "../../style";
import { formateHeader, formateRows } from "../../utils/csvUtils";
import { getFullDateTime } from "../../utils/DateFormatter";

const keyMappings = [
  { key: "loadDate", label: "Load Date" },
  { key: "contract", label: "Contract Number" },
  { key: "ticketNumber", label: "Ticket Number" },
  { key: "origin", label: "Origin" },
  // Add other mappings as necessary
];

export default function DownloadAsCSV(props) {
  const { dataRows = [], headerRows = [] } = props;
  const [fileType, setFileType] = useState("csv");

  // Load fileType from sessionStorage on mount
  useEffect(() => {
    const savedFileType = sessionStorage.getItem("fileType") || "csv";
    setFileType(savedFileType);
  }, []);

  // Update sessionStorage whenever fileType changes
  useEffect(() => {
    sessionStorage.setItem("fileType", fileType);
  }, [fileType]);

  const formatedHeader = formateHeader(headerRows);
  console.log(formatedHeader)
  const formatedRows = formateRows(dataRows);

  const convert = (data) => {
    const keyToLabelMap = formatedHeader.reduce((acc, { key, label }) => {
      acc[key] = label;
      return acc;
    }, {});
  
    const orderedKeys = formatedHeader.map(({ key }) => key);
  
    return data.map((row) => {
      const newRow = {};
      orderedKeys.forEach((key) => {
        if (row[key] !== undefined) {
          newRow[keyToLabelMap[key]] = row[key];
        }
      });
      return newRow;
    });
  };

  const downloadExcel = () => {
    const convertedRows = convert(formatedRows);
    if (!convertedRows.length) return;

    const headers = Object.keys(convertedRows[0]);
    let html = '<table><tr>' + headers.map(h => `<th>${h}</th>`).join('') + '</tr>';
    convertedRows.forEach(row => {
      html += '<tr>' + headers.map(h => `<td>${row[h] !== undefined ? row[h] : ''}</td>`).join('') + '</tr>';
    });
    html += '</table>';

    const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `NTRAC_Report_${getFullDateTime(new Date(), 6)}.xls`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="downloadCSV">
      {fileType === "csv" ? (
        <CSVLink
          filename={`NTRAC_Report_${getFullDateTime(new Date(), 6)}.${fileType}`}
          data={formatedRows} // Use converted rows for CSV as well
          headers={formatedHeader}
          style={{ color: "#00bc84", textDecoration: "none" }}
        >
          <div>
            <FontAwesomeIcon icon={faShareAlt} />
            <span>Export as</span>
          </div>
        </CSVLink>
      ) : (
        <div
          onClick={downloadExcel}
          style={{ cursor: "pointer", color: "#00bc84", textDecoration: "none" }}
        >
          <FontAwesomeIcon icon={faShareAlt} />
          <span>Export as</span>
        </div>
      )}
      <select
        className="downloadOption"
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setFileType(e.target.value)}
        value={fileType}
      >
        <option value="csv">CSV</option>
        <option value="xlsx">Excel</option>
      </select>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/DownloadAsCSV.js